import { BusinessErrorCode } from './contract';

export type CuiValidation =
    | { status: 'empty' }
    | { status: 'invalid'; code: Extract<BusinessErrorCode, 'CUI_INVALID_FORMAT'> }
    | { status: 'valid'; cui: string };

const CUI_FORMAT = /^[0-9]{2,10}$/;
const CHECKSUM_WEIGHTS = [7, 5, 3, 2, 1, 7, 5, 3, 2];

const INVALID: CuiValidation = { status: 'invalid', code: 'CUI_INVALID_FORMAT' };

const hasValidChecksum = (digits: string): boolean => {
    const padded = digits.padStart(10, '0');
    const sum = CHECKSUM_WEIGHTS.reduce(
        (total, weight, index) => total + Number(padded[index]) * weight,
        0,
    );
    const remainder = (sum * 10) % 11;
    return (remainder === 10 ? 0 : remainder) === Number(padded[9]);
};

/**
 * Validates a raw Romanian CUI exactly as typed. Never trims, strips or
 * upper-cases: spaces, an RO prefix, punctuation and non-ASCII digits are all
 * invalid. Every failure is CUI_INVALID_FORMAT, and BOLT must not be called.
 */
export const validateCui = (raw: string): CuiValidation => {
    if (raw === '') {
        return { status: 'empty' };
    }
    if (!CUI_FORMAT.test(raw) || /^0+$/.test(raw) || !hasValidChecksum(raw)) {
        return INVALID;
    }
    return { status: 'valid', cui: raw };
};

export const isValidCui = (raw: string): boolean => validateCui(raw).status === 'valid';
